import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { PoleDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-pole-container',
  templateUrl: './pole-container.component.html',
  styleUrls: ['./pole-container.component.scss'],
})
export class PoleContainerComponent implements OnInit {
  
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  poles$: Observable<PoleDto[]>;
  loading: boolean;
  isLoadingPole$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingPole$ = this.gatwayFacade.isLoadingGateway('Pole');
    this.poles$ = this.gatwayFacade.loadGateway('Pole');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeletePole(deletedValue: any) {
    this.gatwayFacade.remove('Pole', deletedValue);
  }

  // this method control both the create and update

  onSubmitPole(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Poles;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllPole = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllPole.push(pullData[i]);
      }
    }

    // check if the addAllPole array is not empty, then dispatch the data to the store
    if (addAllPole.length > 0) {
      this.gatwayFacade.add('Pole', addAllPole);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('Pole', allUpdates, ['id']);
    }
  }
}
